<template>
    <div id="modal-default" aria-modal="true" class="modal fade show" role="dialog">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <form @submit="submit">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ this.isCreateMode ? 'Create' : 'Edit' }} game</h5>
                        <button aria-label="Close" class="close" data-dismiss="modal" type="button"
                                @click="$emit('close')">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Name</label>
                            <input v-model="currentGame.name"
                                   autocomplete="off"
                                   class="form-control"
                                   name="rate"
                                   placeholder="Enter name"
                                   type="text"
                            >
                        </div>
                        <div class="form-group">
                            <label>Chinese Name (中文名称)</label>
                            <input v-model="currentGame.chineseName"
                                   autocomplete="off"
                                   class="form-control"
                                   name="chinese_name"
                                   placeholder="输入中文名称"
                                   type="text"
                            >
                        </div>
                        <div class="form-check">
                            <input id="checkboxIsActive"
                                   v-model="currentGame.isActive"
                                   autocomplete="off"
                                   class="form-check-input"
                                   name="is_active"
                                   type="checkbox"
                            >
                            <label class="form-check-label" for="checkboxIsActive">Active</label>
                        </div>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <button class="btn btn-default" type="button" @click="$emit('close')">Cancel</button>
                        <button class="btn btn-primary" type="submit">Submit</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<style>
#modal-default {
    display: block;
}
</style>

<script>
const MODE_CREATE = 'create';

export default {
    props: [
        'game',
        'mode',
    ],
    computed: {
        isCreateMode() {
            return this.mode === MODE_CREATE;
        },
        isDebug() {
            return process.env.NODE_ENV === 'development';
        },
    },
    methods: {
        submit(e) {
            e.preventDefault();

            let url = null;
            let method = null;

            if (this.isCreateMode) {
                method = 'POST';
                url = '/games';
            } else {
                method = 'PUT';
                url = '/games/' + this.currentGame.id;
            }

            let postData = {
                name: this.currentGame.name,
                chineseName: this.currentGame.chineseName,
                isActive: this.currentGame.isActive,
            };

            this.$http({
                url: url,
                data: postData,
                method: method,
            }).then(() => {
                this.$emit('finish');
                this.$emit('close');
                this.$store.dispatch('loadGames');
            }).catch((err) => {
                console.error(err);
            });
        },
    },
    mounted() {
        this.$store.dispatch('openModal');
    },
    beforeDestroy() {
        this.$store.dispatch('hideModal');
    },
    data() {
        return {
            currentGame: {...this.game},
        };
    },
};

</script>
